import {
  useAuth,
  useOrganization,
  useOrganizationList,
} from '@clerk/clerk-react';
import { useCallback } from 'react';

import clearCache from '@/actions/cache/clearCache';

export interface UseClearCacheReturn {
  clearCache: () => void;
}

/**
 * Hook for clearing organization cache without waiting for response
 * This is a fire-and-forget operation that doesn't block the UI
 */
export const useClearCache = (): UseClearCacheReturn => {
  const { userId } = useAuth();
  const { organization } = useOrganization();
  const { userMemberships } = useOrganizationList({
    userMemberships: { infinite: true, keepPreviousData: true },
  });

  const clearCacheHandler = useCallback(() => {
    clearCache().catch((error) => {
      console.warn('Failed to clear cache:', error);
    });
  }, [userId, organization?.id, userMemberships.data]);

  return {
    clearCache: clearCacheHandler,
  };
};
